/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M28.532 23.669a1.677 1.677 0 00.735 3.192c.246 0 .503-.059.736-.163a7.57 7.57 0 003.514-10.111 1.684 1.684 0 00-2.253-.781 1.677 1.677 0 00-.782 2.248c1.004 2.097.14 4.613-1.95 5.615zm-17.151-7.385a4.73 4.73 0 014.53-4.916 1.69 1.69 0 001.623-1.748 1.691 1.691 0 00-1.751-1.619c-4.472.187-7.963 3.96-7.776 8.41.035.91.782 1.62 1.681 1.62.981 0 1.717-.78 1.693-1.747z"
    ></path>
    <path
      fill="#B92A2E"
      d="M40.766 61.83a8.638 8.638 0 01-1.844-8.725 8.694 8.694 0 012.58-3.786 16.303 16.303 0 01-5.873-5.708c-4.973-1.48-13.625-4.846-13.625-4.846l.958-12.522 5.3-4.718c.467-.42.654-1.072.502-1.677l-1.53-5.801a1.685 1.685 0 00-1.167-1.2c-.093-.024-2.837-.792-6.094-.501-3.024.28-5.417 1.48-5.522 1.526-.56.28-.923.862-.923 1.49l-.023 9.646-4.67 18.883c-.35 1.42.455 3.087 1.786 3.704l16.964 10.041-4.997 25.266h30.063l1.6-6.756L40.766 61.83zm25.116-7.607c0 1.864.444 3.623 1.214 5.207 5.102 1.83 11.593 4.205 15.995 6.023 4.495-1.83 7.659-6.163 7.659-11.218 0-6.71-5.57-12.15-12.434-12.15-6.865-.011-12.434 5.429-12.434 12.138z"
    ></path>
    <path
      fill="#B92A2E"
      d="M84.163 69.274c-6.094-2.75-21.715-8.224-25.206-9.436l.257-3.18.046.012c.199.07 1.623.559 3.725 1.304a15.286 15.286 0 01-.48-3.75c0-2.004.398-3.914 1.11-5.673l-17.256 2.12a5.305 5.305 0 00-4.238 3.53 5.301 5.301 0 001.168 5.38l14.337 15.074-3.947 17.473h22.977l2.837-7.059h1.635l-1.04 7.06h10.998l1.448-7.363c1.716-7.315-1.366-12.324-8.37-15.492zM36.752 35.515c0 6.954 5.767 12.592 12.89 12.592 7.121 0 12.889-5.638 12.889-12.592 0-6.954-5.768-12.592-12.89-12.592-7.122 0-12.889 5.638-12.889 12.592z"
    ></path>
  </Svg>
)

export default Icon
